import {round} from "lodash";
import modal from "bootstrap/js/src/modal";

const MODAL_CORSO = {
    MODAL_ID: "#modal-corso",
    MODAL_CONTAINER: "#modal-corso-container",
    SPINNER: '#spinner',
    TITLE: '#title',
    DESCRIPTION: '#description',
    VIDEO: "#course-player source",
    CONTENT: "#content",
    BULLETS: "#bullets",
    PRICE: "#price",
    PRICE_OFFER: "#price-offer",
    PRICE_TOTAL: "#price-total",
    DISCOUNT_PERCENTAGE: "#discount-percentage"
}

class ModalCorso {
    constructor() {
    }

    get_modal(modal_id)
    {
        return $(modal_id);
    }

    get_modal_instance(modal_id)
    {
        return new Modal(this.get_modal(modal_id));
    }

    open_modal(modal) {
        modal.show()
    }

    close_modal(modal) {
        modal.hide()
    }

    change_modal_container_content(container, content) {
        container.html(content)
    }

    get_modal_container(modal, input_identifier) {
        return modal.find(input_identifier);
    }

    get_spinner() {
        return "<div class=\"py-4 w-100 d-flex justify-content-center\"> <div class=\"spinner-border text-primary\" role=\"status\"> </div> </div>"
    }

    display_spinner(modal_container) {
        this.change_modal_container_content(modal_container, this.get_spinner())
    }

    reset() {
        $("#modal-corso #title").addClass('hide')
        $("#modal-corso #description").addClass('hide')
        $("#modal-corso #content").addClass('hide')
        $("#modal-corso #bullets").addClass('hide')
        $("#modal-corso #price").addClass('hide')
        $("#modal_corso_add_related_form").addClass('hide')
        $("#modal-corso #spinner").removeClass('hide')
        $("#course-popup-player")[0].pause()
        $("#promotion-actions-section").addClass('hide')
    }
}

const modal_corso = new ModalCorso();

$(function () {
    let drag = false;

    $(document).on('mousedown', "[data-type='open-course-modal']", () => drag = false)
    $(document).on('mousemove', "[data-type='open-course-modal']", () => drag = true)
    $(document).on('click', "[data-type='open-course-modal']", function (e) {e.preventDefault()})

    $(document).on('mouseup', "[data-type='open-course-modal']", function (e) {
        e.preventDefault()
        if (drag) {return;}

        let $this = $(this)
        const _course_id = $this.data('course_id')
        const _product_id = $this.data('product_id')
        const _course_price = $this.data('price')
        const _action = $this.data('action')
        const _course_slug = $this.data('course_slug')
        let _partnership_id = null
        let _access_source = "PROMO_PAGE"

        if ($this.data('partnership_id')) {
             _partnership_id = $this.data('partnership_id')
             _access_source = "PARTNERSHIP_PAGE"

            if (!$this.data('page_exit')) {
                $('#promo-info').addClass('d-none')
            }
        }

        //for course pack promotion
        const coursePackPromotionId = $this.data('course-pack-promotion')
        const coursePackProductId = $this.data('course-pack-product')
        const userPackId = $this.data('user-pack')
        const packProductId = $this.data('pack-product')
        const courseNumber = $this.data('course-number')
        const packPrice = $this.data('pack-price')
        const isAlreadyInPack = $this.data('already-in-pack')

        if (! _course_id) {

            return false;
        }

        const _modal = modal_corso.get_modal(MODAL_CORSO.MODAL_ID)
        const _modal_instance = modal_corso.get_modal_instance(MODAL_CORSO.MODAL_ID)
        const _spinner_container = modal_corso.get_modal_container(_modal, MODAL_CORSO.SPINNER)

        modal_corso.display_spinner(_spinner_container)
        modal_corso.open_modal(_modal_instance)

        $(document).on('hide.bs.modal', _modal, function (event) {
            modal_corso.reset()
        })

        $.ajax({
            url: '/courses/modal-data',
            data: {course_id: _course_id, product_id: _product_id},
            method: 'POST',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response, status, xhr) {
            const _course = response.data.course;
            const _in_cart = response.data.inCart;
            const _title = modal_corso.get_modal_container(_modal, MODAL_CORSO.TITLE)
            const _description = modal_corso.get_modal_container(_modal, MODAL_CORSO.DESCRIPTION)
            const _content = modal_corso.get_modal_container(_modal, MODAL_CORSO.CONTENT)
            const _bullets = modal_corso.get_modal_container(_modal, MODAL_CORSO.BULLETS)
            const _price = modal_corso.get_modal_container(_modal, MODAL_CORSO.PRICE)
            const _price_offer = modal_corso.get_modal_container(_modal, MODAL_CORSO.PRICE_OFFER)
            const _price_total = modal_corso.get_modal_container(_modal, MODAL_CORSO.PRICE_TOTAL)
            const _discount_percentage = modal_corso.get_modal_container(_modal, MODAL_CORSO.DISCOUNT_PERCENTAGE)

            $(_spinner_container).addClass('hide')

            let price_label = "€ "+round(_course_price, 2);
            let list_price_label = "€ "+round(_course.product.list_price, 2);

            if (_course_price === 0) {
                price_label = "<span class=\"badge rounded-pill bg-premium\">Gratis per te</span>"
                list_price_label = "";
            }

            if (_action === 'add-to-user-pack') {
                if (isAlreadyInPack) {
                    $('#course-pack-added-to-user-pack').removeClass('hide')
                    $('#course-pack-add-to-user-pack').addClass('hide')
                }
                let discountAmount = _course_price - (packPrice / courseNumber)
                let discountPercentage = parseInt((discountAmount / _course_price) * 100)
                let discountLabel = discountPercentage + "% di sconto"
                modal_corso.change_modal_container_content(_discount_percentage, discountLabel)
            }

            modal_corso.change_modal_container_content(_title, _course.title)
            modal_corso.change_modal_container_content(_description, _course.excerpt)
            modal_corso.change_modal_container_content(_price_offer, price_label)
            modal_corso.change_modal_container_content(_price_total,list_price_label)

            const _bullet_points = _course.bullet_points.map(function (bullet_point) {
                return `<small class="m-0"><i class="fas fa-check"></i> <span>${bullet_point}</span></small><br>`;
            })

            modal_corso.change_modal_container_content(_bullets, _bullet_points)
            $('#course-popup-player source').attr('src', _course.lessons[0].video_sources_url.sd)
            $("#course-popup-player")[0].load();

            $(_title).removeClass('hide')
            $(_description).removeClass('hide')
            $(_content).removeClass('hide')
            $(_bullets).removeClass('hide')
            $(_price).removeClass('hide')

            if (_action === 'add-to-cart') {
                $("#modal_corso_cart_product_id").val(_product_id)
                $("#modal_corso_add_related_form").removeClass('hide')
            }

            if (_in_cart) {
                $("#promo-added-to-cart").removeClass('hide')
                $("#promo-add-to-cart").addClass('hide')
            } else {
                $("#promo-added-to-cart").addClass('hide')
                $("#promo-add-to-cart").removeClass('hide')
            }

            $("#promotion-actions-section").removeClass('hide')
            $("#course-pack-actions-section").removeClass('hide')

          $("#promo-info").click(() => {
            window.location.href = "/corso/" + _course_slug + "?pid=" + _product_id;;
          });

            var promo_add_to_cart_button = $("#promo-add-to-cart");

            promo_add_to_cart_button.click(() => {
                // Spinner nel pulsante aggiungi al carrello
                promo_add_to_cart_button.html(
                    "<span class='text-white'>Sto aggiungendo</span> <i class='fas fa-circle-notch fa-spin text-white'></i>"
                )
                promo_add_to_cart_button.blur();
                promo_add_to_cart_button.addClass('disabled')
                $.ajax({
                    url: '/cart/add',
                    data: {product_id: _product_id, access_source: _access_source, partnership_id: _partnership_id},
                    method: 'POST',
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function (response, status, xhr) {
                    if (response.data) {
                        location.reload()
                    }
                }).fail(function (error) {
                })
            })

            let course_pack_add_to_user_pack_btn = $("#course-pack-add-to-user-pack");

            course_pack_add_to_user_pack_btn.click(() => {
                course_pack_add_to_user_pack_btn.html(
                    "<span class='text-white'>Sto aggiungendo</span> <i class='fas fa-circle-notch fa-spin text-white'></i>"
                )
                course_pack_add_to_user_pack_btn.blur();
                course_pack_add_to_user_pack_btn.addClass('disabled')
                $.ajax({
                    url: '/crea-il-tuo-pacchetto/user-pack/create-pack',
                    data: {course_pack_product_id: coursePackProductId, pack_product_id: packProductId, user_pack_id: userPackId, course_pack_promotion_id: coursePackPromotionId},
                    method: 'POST',
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(function (response, status, xhr) {
                    $('#course-pack-added-to-user-pack').removeClass('hide')
                    $('#course-pack-add-to-user-pack').addClass('hide')
                    if (response.data) {
                        location.reload()
                    }
                }).fail(function (error) {
                })
            })

        }).fail(function (error) {
            modal_corso.close_modal(_modal_instance)
        })
    })
})
